import React from 'react';

import PreSalesList from '../../../components/staff/pre-sales-list';

const PreSalesIndex = () => (
  <>
    <h1>Pre-ventas</h1>
    <PreSalesList/>
  </>
);

export default PreSalesIndex;
